export default "__VITE_PUBLIC_ASSET__206fe765__"